module.exports = __webpack_public_path__ + "img/arrow-right-square-fill.8b2eb253.svg";